module.exports = __webpack_public_path__ + "public/images/nature.9c2291c39ff2009d9ba8c0557a57f5a7.png";